import nav from '../components/nav';
import rightSideWidgets from '../components/right-side-widgets';
import forms from '../components/forms';
import headerSlider from '../components/header-slider';
import showcaseSlider from '../components/showcase-slider';
import postsPreview from '../components/posts-preview';
import imagesSlider from '../components/images-slider';
import reasonsToStay from '../components/reasons-to-stay';
import quickLinks from '../components/quick-links';
import quickLinksTwo from '../components/quick-links-2';
import instagramFeed from '../components/instagram-feed';
import faqAccordion from '../components/faq-accordion';
import gallery from '../components/gallery';
import weddingPackage from '../components/wedding-package';
import fixPaddings from '../util/fix-paddings';
import findARoom from '../components/find-a-room';
import bookATable from '../components/book-a-table';
import downloadBrochure from '../components/download-brochure';
import featureSlider from '../components/feature-slider';
import tilesGallery from '../components/tiles-gallery';
//import cart from '../components/cart';
import cookieWarning from '../components/cookie-warning';
import noticeModal from '../components/notice-modal';
import edmModal from '../components/edm-modal';
import  signUp from '../components/signup-bar';

export default {
  init() {
$(document).ready(() => {
        $('[href=#open-popup-competition]').click(() => {
                $('body').css('overflow', 'hidden');
                $('#competition-popup').addClass('open');
        });

        $('.close, #competition-popup-backdrop').click(() => {
                $('body').css('overflow', 'auto');
                $('#competition-popup').removeClass('open');
        });
});

    // JavaScript to be fired on all pages
  },
  finalize() {
    forms();
    nav();
    headerSlider();
    rightSideWidgets();
    downloadBrochure();
    showcaseSlider();
    postsPreview();
    imagesSlider();
    reasonsToStay();
noticeModal();
    quickLinks();
    quickLinksTwo();
    instagramFeed();
    faqAccordion();
    gallery();
    weddingPackage();
    fixPaddings();
    findARoom();
    bookATable();
    featureSlider();
    tilesGallery();
    //cart();
    cookieWarning();
    edmModal();
    signUp();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js